import styled from 'styled-components'

export const DocumentBase = styled.article`
  padding-bottom: 400px;
  font-size: 14px;
  hr {
    height: 0;
    border: 0;
    border-top: 1px solid #e1e1e8;
    margin: 15px 0 15px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 20px 0 10px;
  }
  h1 {
    font-size: 34px;
  }
  h2 {
    font-size: 30px;
  }
  h3 {
    font-size: 20px;
  }
  h4 {
    font-size: 18px;
  }
  h5 {
    font-size: 16px;
  }
  h6 {
    font-size: 14px;
  }
  section {
    margin-bottom: 50px;
  }
  p {
    margin-bottom: 10px;
  }
  ul,
  ol {
    margin-left: 30px;
    padding-left: 0;
  }
  pre {
    padding: 10px 15px;
    border: 1px solid #e1e1e8;
    border-radius: 4px;
    font-family: 'Droid Sans Mono', monospace;
    font-size: 14px;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    white-space: pre-wrap;
    word-wrap: break-word;
    background-color: #50556b;
    color: #fff;
  }
  blockquote {
    padding: 10px 20px;
    margin: 0 0 20px;
    font-size: 17.5px;
    border-left: 5px solid #eee;
  }

  label {
    font-weight: bold;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  input,
  select,
  .select,
  textarea {
    background: #fff;
    border: 1px solid #ddd;
    -webkit-border-radius: 0;
    -webkit-appearance: none;
    border-radius: 0;
    box-sizing: border-box;
    line-height: 17px;
    height: 32px;
    width: 100%;
    padding: 6px 8px 6px 8px;
    margin-bottom: 25px;
    font-size: inherit;
  }
  input[type='text'],
  input[type='email'],
  input[type='tel'],
  input[type='url'],
  input[type='password'] {
    -webkit-appearance: none;
  }
  select {
    cursor: pointer;
  }
  textarea {
    min-height: 68px;
    overflow: auto;
  }
  form button {
    margin-bottom: 25px;
    height: 32px;
  }
  img {
    max-width: 100%;
  }
  a {
    color: #f2063f;
    text-decoration: none;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    margin: 0 0 20px 0;
  }
  th {
    background-color: #F9FBFF;
    text-align: left;
    font-weight: 700;
    padding: 6px 10px;
    border: #BDC5D7 1px solid;
  }
  td {
    padding: 6px 10px;
    border: #BDC5D7 1px solid;
  }
  code {
    padding: 2px 4px;
    font-size: 90%;
    color: #c7254e;
    background-color: #f9f2f4;
    border-radius: 4px;
  }
  .label-optional {
    float: right;
    text-align: center;
    padding: 0.2em 0.6em;
    border-radius: 0.25em;
    line-height: 1;
    color: #fff;
    background-color: grey;
  }
  .type {
    font-weight: 600;
    font-size: 15px;
    display: inline-block;
    padding: 0.2em 0.6em;
    border-radius: 4px;
    text-transform: uppercase;
    background-color: #f2063f;
    color: #fff;
  }
`
